import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from "react";
import { ArticleLinksView } from "../ArticleLinksView";
import { STEP } from "../consts";
import { useLoggedOutContactUsContextStore } from "../hooks/LoggedOutContactUsContextStore";
import { LoggedOutConfirmationView } from "./LoggedOutConfirmationView";
import { LoggedOutContactUsView } from "./LoggedOutContactUsView";
import { LoggedOutSelectTopicView } from "./LoggedOutSelectTopicView";
export var LoggedOutContactUsStepView = function LoggedOutContactUsStepView() {
  var _useLoggedOutContactU = useLoggedOutContactUsContextStore(["currentStep"]),
    _useLoggedOutContactU2 = _slicedToArray(_useLoggedOutContactU, 1),
    currentStep = _useLoggedOutContactU2[0].currentStep;
  switch (currentStep) {
    case STEP.HELP_CENTER_ARTICLE:
      return /*#__PURE__*/React.createElement(ArticleLinksView, null);
    case STEP.CONFIRMATION:
      return /*#__PURE__*/React.createElement(LoggedOutConfirmationView, null);
    case STEP.LOGGED_OUT_SELECT_TOPIC:
      return /*#__PURE__*/React.createElement(LoggedOutSelectTopicView, null);
    case STEP.LOGGED_OUT_CONTACT_US:
      return /*#__PURE__*/React.createElement(LoggedOutContactUsView, null);
    default:
      return /*#__PURE__*/React.createElement(LoggedOutSelectTopicView, null);
  }
};